import { render, staticRenderFns } from "./SEO.vue?vue&type=template&id=a1982c3e&scoped=true"
import script from "./SEO.vue?vue&type=script&lang=js"
export * from "./SEO.vue?vue&type=script&lang=js"
import style0 from "./SEO.vue?vue&type=style&index=0&id=a1982c3e&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1982c3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1982c3e')) {
      api.createRecord('a1982c3e', component.options)
    } else {
      api.reload('a1982c3e', component.options)
    }
    module.hot.accept("./SEO.vue?vue&type=template&id=a1982c3e&scoped=true", function () {
      api.rerender('a1982c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/productDetail/SEO.vue"
export default component.exports